module.exports = __webpack_public_path__ + "img/relation_shape2.68ad168.svg";